export interface Location {
  id: string
  // TODO: Inflate a country code on load for ease of use?
  state: string // {2-char country code}-{state code}
  county: string // name of the county, not the code, todo: change that?
  name: string
  latitude: number
  longitude: number
}

// TODO: Do the obsTo* in terms of the obsBy* functions?
export function locCountryCode(loc: Location): string {
  return loc.state.slice(0,2);
}
